export enum MatchStatus {
  New = 'new',
  Accepted = 'accepted',
  Pending = 'pending',
  Contacted = 'contacted',
  Interview = 'interview',
  Hired = 'hired',
  Rejected = 'rejected',
  OnHold = 'on_hold',
}
